/** Attributes so LastPass and 1Password skip these inputs (no save/fill suggestions). */
export const PASSWORD_MANAGER_IGNORE = {
  "data-lpignore": "true",
  "data-1p-ignore": true,
} as const;
